const SessionActions = {
    timeout: "session/timeout",
    timeoutImminent: "session/timeoutImminent"
};

export default SessionActions;



// WEBPACK FOOTER //
// ./app/data/SessionActions.js